import {Grid, makeStyles, Typography} from "@material-ui/core";
import {
    DeleteButton,
    FunctionField,
    NumberField,
    Record,
    TextField,
    useListContext,
    useRecordContext,
} from "react-admin";
import {EditableDatagrid,} from "../../components/EditableDatagrid";


import {useOptions} from "../../shared/hooks/useOptions";
import {initField} from "../../shared/utils";
import {getChartAccountBalance} from "./chartAccountBalance";

const useStyles = makeStyles({
  root: {
    padding: '30px',
  },
});

export const InvoiceChartAccountsDatagrid = () => {
  const { data: optionsinvoiceLines } = useOptions("invoice-lines", "GET");
  const { data: optionsInvoiceChartAccounts } = useOptions("invoicechartaccounts", "GET");
  const record = useRecordContext();
  const {
    data,
    selectedIds,
  } = useListContext();
  const {sum, rest, exceedsTotal} = getChartAccountBalance(
    record.amount,
    Object.values(data || {}).map(row => row.amount)
  );

  const classes = useStyles();

  return optionsinvoiceLines && optionsInvoiceChartAccounts ? (
    <>
      <Grid className={classes.root} container spacing={2}>
        <Grid item xs={6}>
          {exceedsTotal ? (
            <Typography variant="h5" color="error">
              Associati al piano dei conti: {sum.toFixed(2)} €
              <br></br>
              Attenzione importo superiore al totale della fattura
            </Typography>
          ) : (
            <Typography variant="h5">Associati al piano dei conti: {sum.toFixed(2)} €</Typography>
          )
          }


        </Grid>

        <Grid item xs={6}>
          <Typography variant="h5" color={rest.toFixed(2) !== "0.00" ? ("error") : ("initial")}>
            Non associati al piano dei conti: {rest.toFixed(2)} €
          </Typography>
        </Grid>

      </Grid>

      <EditableDatagrid
        selectedIds={selectedIds}
      >
        <TextField source="chart_accounts_objects.code" label="Cod. Piano dei conti" />
        <TextField source="chart_accounts_objects.name" label="Piano dei conti" />
        <TextField source="site__business_name" label="Sede" />
        <NumberField {...initField("amount", optionsinvoiceLines)} />
        {record.status !== "C" && (
          <FunctionField
            render={(record?: Record) =>
              record ? (
                <DeleteButton redirect={false} record={record} />
              ) : null
            }
          />
        )}
      </EditableDatagrid>

    </>
  ) : null;
};
